import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import PageHeader from '@/components/layouts/PageHeader'
import CountrySelector from '@/features/bidding/components/CountrySelector'

/**
 * Header shell for the new bid detail page. Renders the page title plus a
 * breadcrumb back to the bidding overview, and includes a disabled country
 * selector in the app-bar slot for visual consistency with the legacy
 * `/bidding/view` page.
 *
 * Bid-type-agnostic — the same header is used for the Energy and Capacity tabs.
 */
export default function BidDetailHeader() {
  const { t } = useTranslation()

  return (
    <PageHeader
      appBarContent={
        <Box alignItems="center" display="flex" flexDirection="row" sx={{ width: '100%' }}>
          <Box display="flex" flexDirection="row" sx={{ flex: 1, justifyContent: 'left' }}>
            <CountrySelector disabled />
          </Box>
        </Box>
      }
      breadcrumbItems={[{ text: t('component.page_header.bidding'), to: '/bidding' }]}
      pageTitle={t('component.page_header.bid.results.label')}
    />
  )
}
